import { useCallback } from 'react';
import { useAuthStore } from '../stores/auth';
import { useCatalog } from '../stores/catalog';
import { apiRequest } from '../lib/api';

export function useSignOut() {
  return useCallback(async () => {
    await apiRequest('/auth/logout', { method: 'POST' });
    useCatalog.getState().reset();
    useAuthStore.getState().clearAuth({ signedOut: true });
  }, []);
}
